import { render, staticRenderFns } from "./StatisticByUser.vue?vue&type=template&id=5e434f9c&"
import script from "./StatisticByUser.vue?vue&type=script&lang=js&"
export * from "./StatisticByUser.vue?vue&type=script&lang=js&"
import style0 from "./StatisticByUser.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports